module.exports = __webpack_public_path__ + "favicon.ico?2f3f9f018cb6ffca853c5d8be7dca7d1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/favicon.ico
// module id = 621
// module chunks = 0